import { chartTableFlatTransformer } from '../chartTableFlatTransformer';
import { getPercentage } from './tableUtils';

// Live job pipeline uses _actual_count keys from API, maps to _total_count for PipelineTable compatibility
const tableWithTotal = ({ data = [] }) => {
  const prospect_total = data?.reduce(
    (acc, curr) => acc + curr?.prospect_actual_count,
    0
  );
  const application_review_total = data?.reduce(
    (acc, curr) => acc + curr?.application_review_actual_count,
    0
  );
  const interviews_total = data?.reduce(
    (acc, curr) => acc + curr?.interviews_actual_count,
    0
  );
  const offer_total = data?.reduce(
    (acc, curr) => acc + curr?.offer_actual_count,
    0
  );
  const hired_total = data?.reduce(
    (acc, curr) => acc + curr?.hired_actual_count,
    0
  );

  // Sum each stage's time (seconds) so the Total row can show the count-weighted
  // average time-in-stage: SUM(time_in_stage) / SUM(stage_actual_count).
  const time_in_prospect_total = data?.reduce(
    (acc, curr) => acc + (curr?.time_in_prospect || 0),
    0
  );
  const time_in_application_review_total = data?.reduce(
    (acc, curr) => acc + (curr?.time_in_application_review || 0),
    0
  );
  const time_in_interviews_total = data?.reduce(
    (acc, curr) => acc + (curr?.time_in_interviews || 0),
    0
  );
  const time_in_offer_total = data?.reduce(
    (acc, curr) => acc + (curr?.time_in_offer || 0),
    0
  );

  function innerFunc(data) {
    if (!data?.length) return [];
    return data.map((datum) => {
      const row = { ...datum };
      // Map _actual_count to _total_count for PipelineTable compatibility
      row.prospect_total_count = datum?.prospect_actual_count;
      row.application_review_total_count =
        datum?.application_review_actual_count;
      row.interviews_total_count = datum?.interviews_actual_count;
      row.offer_total_count = datum?.offer_actual_count;
      row.hired_total_count = datum?.hired_actual_count;

      row.prospect_total_count_total = prospect_total;
      row.prospect_actual_count_total = prospect_total;
      row.prospect_total_count_per = getPercentage(
        datum?.prospect_actual_count,
        prospect_total
      );

      row.application_review_total_count_total = application_review_total;
      row.application_review_actual_count_total = application_review_total;
      row.application_review_total_count_per = getPercentage(
        datum?.application_review_actual_count,
        application_review_total
      );

      row.interviews_total_count_total = interviews_total;
      row.interviews_actual_count_total = interviews_total;
      row.interviews_total_count_total_per = getPercentage(
        datum?.interviews_actual_count,
        interviews_total
      );

      row.offer_total_count_total = offer_total;
      row.offer_actual_count_total = offer_total;
      row.offer_total_count_per = getPercentage(
        datum?.offer_actual_count,
        offer_total
      );

      row.hired_total_count_total = hired_total;
      row.hired_actual_count_total = hired_total;
      row.hired_total_count_per = getPercentage(
        datum?.hired_actual_count,
        hired_total
      );

      // Per-stage time totals (Total-row numerator for avg time-in-stage).
      row.time_in_prospect_total = time_in_prospect_total;
      row.time_in_application_review_total = time_in_application_review_total;
      row.time_in_interviews_total = time_in_interviews_total;
      row.time_in_offer_total = time_in_offer_total;

      row.subRows = innerFunc(datum?.subRows);

      return row;
    });
  }

  return innerFunc(data);
};

export const liveJobPipelineTableTransformer = ({ response, args }) => {
  const { chart = [], headers, lookups, table = [] } = response || {};
  const { dt, g1, g2, g1_l2, g2_l2 } = lookups || {};

  const data = g1?.length || g2?.length ? table : chart;
  const headerKey = g1?.length ? 'g1' : 'dt';

  const { group_by_1, group_by_2 } = args || {};

  const transformedData = chartTableFlatTransformer({
    headerKey,
    headers,
    data,
    g1,
    g2,
    dt,
    g1_l2,
    g2_l2,
    g1Key: group_by_1?.id || group_by_1,
    g2Key: group_by_2?.id || group_by_2,
  });

  return tableWithTotal({ data: transformedData });
};
